// import React, { useState, useEffect, useRef } from "react";
// import getAddressLatLong from "../utils/getAddressLatLong";

// // Store List Component
// const StoreList = ({ stores, startStore, onStoreClick }) => {
//   return (
//     <div>
//       <h3 className="text-lg font-semibold text-gray-800 mb-3">
//         📍 Available Stores ({stores.length})
//       </h3>
//       <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
//         {stores.map((store) => (
//           <div
//             key={store.id}
//             onClick={() => onStoreClick(store)}
//             className={`p-4 border-2 rounded-lg transition-all cursor-pointer ${
//               startStore?.id === store.id
//                 ? "border-red-500 bg-red-50 shadow-md"
//                 : "border-gray-200 hover:border-indigo-400 hover:bg-indigo-50"
//             }`}
//           >
//             <p className="font-bold text-gray-800">{store.name}</p>
//             <p className="text-sm text-gray-600">
//               {store.city}, {store.state}
//             </p>
//             {store.lat && store.lng && (
//               <p className="text-xs text-gray-400 mt-1">
//                 {store.lat.toFixed(4)}, {store.lng.toFixed(4)}
//               </p>
//             )}
//             {startStore?.id === store.id && (
//               <span className="inline-block mt-2 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full">
//                 STARTING POINT
//               </span>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Sequential Route Display Component
// const SequentialRouteDisplay = ({ sequentialRoute, isCalculating }) => {
//   if (isCalculating) {
//     return (
//       <div className="flex items-center justify-center h-[500px] bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
//           <p className="text-gray-500 font-semibold">Calculating routes...</p>
//           <p className="text-gray-400 text-sm mt-2">
//             Fetching distances from Google Maps
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (sequentialRoute.length === 0) {
//     return (
//       <div className="flex items-center justify-center h-[500px] bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
//         <div className="text-center">
//           <div className="text-6xl mb-4">🗺️</div>
//           <p className="text-gray-500 font-semibold">Select a starting store</p>
//           <p className="text-gray-400 text-sm mt-2">
//             Click on any store to see the sequential route
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="flex justify-between items-center mb-3">
//         <h3 className="text-lg font-semibold text-gray-800">
//           🚗 Sequential Route (A → B → C → D...)
//         </h3>
//         <div className="text-sm font-semibold text-gray-600">
//           Total:{" "}
//           {sequentialRoute[sequentialRoute.length - 1].cumulativeDistance} |{" "}
//           {sequentialRoute[sequentialRoute.length - 1].cumulativeTime}
//         </div>
//       </div>

//       {/* Explanation Box */}
//       <div className="mb-4 p-4 bg-blue-50 border-2 border-blue-300 rounded-lg">
//         <h4 className="font-bold text-blue-900 mb-2">
//           📊 Understanding the Metrics:
//         </h4>
//         <div className="space-y-2 text-sm text-blue-800">
//           <div>
//             <span className="font-bold">Segment Distance:</span> Actual road
//             distance between current stop and next stop (via Google Maps)
//           </div>
//           <div>
//             <span className="font-bold">Segment Time:</span> Estimated travel
//             time for that segment (from Google Maps)
//           </div>
//           <div>
//             <span className="font-bold">Total Distance:</span> Cumulative
//             distance from start to current stop
//           </div>
//           <div>
//             <span className="font-bold">Total Time:</span> Cumulative time from
//             start to current stop
//           </div>
//         </div>
//       </div>

//       <div className="space-y-3 max-h-[450px] overflow-y-auto pr-2">
//         {sequentialRoute.map((segment, index) => (
//           <div
//             key={index}
//             className="p-4 border-2 border-orange-200 bg-gradient-to-r from-orange-50 to-amber-50 rounded-lg hover:shadow-md transition"
//           >
//             <div className="flex items-center gap-3 mb-3">
//               <div className="bg-orange-600 text-white font-bold w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
//                 {index + 1}
//               </div>
//               <div className="flex-1">
//                 <p className="font-bold text-gray-800 text-lg">
//                   {segment.from} → {segment.to}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   {segment.fromCity} → {segment.toCity}
//                 </p>
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4 pt-3 border-t-2 border-orange-200">
//               <div className="bg-white p-3 rounded-lg">
//                 <p className="text-xs text-gray-500 mb-1">
//                   🔹 Segment Distance
//                 </p>
//                 <p className="font-bold text-gray-800 text-lg">
//                   {segment.distanceText || segment.distance}
//                 </p>
//                 <p className="text-xs text-gray-500 mt-1">This leg only</p>
//               </div>
//               <div className="bg-white p-3 rounded-lg">
//                 <p className="text-xs text-gray-500 mb-1">⏱️ Segment Time</p>
//                 <p className="font-bold text-gray-800 text-lg">
//                   {segment.timeText || segment.time}
//                 </p>
//                 <p className="text-xs text-gray-500 mt-1">This leg only</p>
//               </div>
//               <div className="bg-blue-50 p-3 rounded-lg border-2 border-blue-300">
//                 <p className="text-xs text-blue-600 mb-1 font-semibold">
//                   📏 Total Distance
//                 </p>
//                 <p className="font-bold text-blue-700 text-lg">
//                   {segment.cumulativeDistance}
//                 </p>
//                 <p className="text-xs text-blue-600 mt-1">From start</p>
//               </div>
//               <div className="bg-blue-50 p-3 rounded-lg border-2 border-blue-300">
//                 <p className="text-xs text-blue-600 mb-1 font-semibold">
//                   ⏰ Total Time
//                 </p>
//                 <p className="font-bold text-blue-700 text-lg">
//                   {segment.cumulativeTime}
//                 </p>
//                 <p className="text-xs text-blue-600 mt-1">From start</p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="mt-4 p-3 bg-green-50 border border-green-300 rounded-lg">
//         <p className="text-xs text-green-800">
//           ✓ Route optimized by nearest-first algorithm
//           <br />✓ Distances and times from Google Maps Distance Matrix API
//           <br />✓ Blue polyline shows the complete route on map
//         </p>
//       </div>
//     </>
//   );
// };

// // Google Map Component
// const GoogleMapComponent = ({
//   startStore,
//   sequentialRoute,
//   stores,
//   apiKey,
// }) => {
//   const mapRef = useRef(null);
//   const [map, setMap] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!apiKey || apiKey === "YOUR_API_KEY_HERE") {
//       setError("Please add your Google Maps API key");
//       return;
//     }

//     const loadScript = () => {
//       if (window.google && window.google.maps) {
//         initMap();
//         return;
//       }

//       const script = document.createElement("script");
//       script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
//       script.async = true;
//       script.defer = true;
//       script.onload = initMap;
//       script.onerror = () => setError("Failed to load Google Maps");
//       document.head.appendChild(script);
//     };

//     loadScript();
//   }, [apiKey]);

//   useEffect(() => {
//     if (map && startStore) {
//       updateMap();
//     }
//   }, [map, startStore, sequentialRoute]);

//   const initMap = () => {
//     if (!mapRef.current) return;

//     const mapInstance = new window.google.maps.Map(mapRef.current, {
//       zoom: 5,
//       center: { lat: 23.5, lng: 78.9 },
//       mapTypeId: "roadmap",
//     });

//     setMap(mapInstance);
//   };

//   const updateMap = () => {
//     if (!map || !window.google || !startStore) return;

//     // Clear old markers
//     if (map.markers) {
//       map.markers.forEach((m) => m.setMap(null));
//     }
//     map.markers = [];

//     // Clear old directions
//     if (map.directionsRenderers) {
//       map.directionsRenderers.forEach((r) => r.setMap(null));
//     }
//     map.directionsRenderers = [];

//     const bounds = new window.google.maps.LatLngBounds();

//     // START MARKER (RED)
//     const startMarker = new window.google.maps.Marker({
//       position: { lat: startStore.lat, lng: startStore.lng },
//       map,
//       title: startStore.name,
//       icon: {
//         path: "M12 0C7.58 0 4 3.58 4 8c0 5.5 8 14 8 14s8-8.5 8-14c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
//         fillColor: "#D32F2F",
//         fillOpacity: 1,
//         strokeColor: "#B71C1C",
//         strokeWeight: 2,
//         scale: 1.8,
//       },
//       label: {
//         text: "START",
//         color: "#fff",
//         fontWeight: "bold",
//         fontSize: "10px",
//       },
//     });

//     map.markers.push(startMarker);
//     bounds.extend(startMarker.getPosition());

//     // STOP MARKERS (ORANGE)
//     sequentialRoute.forEach((segment, index) => {
//       const marker = new window.google.maps.Marker({
//         position: { lat: segment.lat, lng: segment.lng },
//         map,
//         title: `Stop ${index + 1}: ${segment.to}`,
//         icon: {
//           path: "M12 0C7.58 0 4 3.58 4 8c0 5.5 8 14 8 14s8-8.5 8-14c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
//           fillColor: "#FF9800",
//           fillOpacity: 1,
//           strokeColor: "#E65100",
//           strokeWeight: 2,
//           scale: 1.3,
//         },
//         label: {
//           text: `${index + 1}`,
//           color: "#fff",
//           fontWeight: "bold",
//         },
//       });

//       const infoWindow = new window.google.maps.InfoWindow({
//         content: `
//         <div style="padding:8px">
//           <b>${segment.to}</b><br/>
//           From: ${segment.from}<br/>
//           Segment: ${segment.distanceText || segment.distance}<br/>
//           Time: ${segment.timeText || segment.time}<br/>
//           <span style="color:#1976D2">
//             Total: ${segment.cumulativeDistance} (${segment.cumulativeTime})
//           </span>
//         </div>
//       `,
//       });

//       marker.addListener("click", () => infoWindow.open(map, marker));
//       map.markers.push(marker);
//       bounds.extend(marker.getPosition());
//     });

//     // DRAW ROUTES IN CHUNKS (23 waypoints max per request)
//     if (sequentialRoute.length > 0) {
//       const directionsService = new window.google.maps.DirectionsService();
//       const CHUNK_SIZE = 23;

//       const chunks = [];
//       for (let i = 0; i < sequentialRoute.length; i += CHUNK_SIZE) {
//         chunks.push(sequentialRoute.slice(i, i + CHUNK_SIZE));
//       }

//       chunks.forEach((chunk, chunkIndex) => {
//         const origin =
//           chunkIndex === 0
//             ? { lat: startStore.lat, lng: startStore.lng }
//             : {
//                 lat: chunks[chunkIndex - 1][chunks[chunkIndex - 1].length - 1]
//                   .lat,
//                 lng: chunks[chunkIndex - 1][chunks[chunkIndex - 1].length - 1]
//                   .lng,
//               };

//         const destination = {
//           lat: chunk[chunk.length - 1].lat,
//           lng: chunk[chunk.length - 1].lng,
//         };
//         const waypoints = chunk.slice(0, -1).map((s) => ({
//           location: { lat: s.lat, lng: s.lng },
//           stopover: true,
//         }));

//         const directionsRenderer = new window.google.maps.DirectionsRenderer({
//           suppressMarkers: true,
//           polylineOptions: {
//             strokeColor: "#1976D2",
//             strokeWeight: 5,
//             strokeOpacity: 0.9,
//           },
//           preserveViewport: true,
//         });

//         directionsRenderer.setMap(map);
//         map.directionsRenderers.push(directionsRenderer);

//         directionsService.route(
//           {
//             origin: origin,
//             destination: destination,
//             waypoints: waypoints,
//             travelMode: window.google.maps.TravelMode.DRIVING,
//           },
//           (result, status) => {
//             if (status === "OK") {
//               directionsRenderer.setDirections(result);
//             } else {
//               console.error(
//                 `Directions failed for chunk ${chunkIndex}:`,
//                 status
//               );
//             }
//           }
//         );
//       });
//     }

//     map.fitBounds(bounds);
//   };

//   if (error) {
//     return (
//       <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-6 text-center">
//         <div className="text-4xl mb-3">🔑</div>
//         <p className="text-yellow-800 font-semibold mb-2">{error}</p>
//         <p className="text-sm text-yellow-700 mb-4">
//           Add your Google Maps API key in environment variables
//         </p>
//         <p className="text-xs text-yellow-600">
//           Get key from:{" "}
//           <a
//             href="https://console.cloud.google.com/google/maps-apis"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="underline font-semibold"
//           >
//             Google Cloud Console
//           </a>
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div
//         ref={mapRef}
//         className="w-full h-[600px] rounded-lg border-2 border-gray-300 shadow-lg"
//       />
//       <div className="mt-3 p-3 bg-white border border-gray-200 rounded-lg flex flex-wrap gap-4 items-center justify-center text-sm">
//         <div className="flex items-center gap-2">
//           <div className="w-6 h-6 bg-red-600 rounded-full"></div>
//           <span className="font-semibold">Starting Point (Red)</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
//           <span className="font-semibold">Route Stops (Orange)</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <div className="w-8 h-1 bg-blue-600"></div>
//           <span className="font-semibold">Route Path (Blue)</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Search and Filter Component
// const SearchFilter = ({
//   searchTerm,
//   setSearchTerm,
//   selectedCity,
//   setSelectedCity,
//   cities,
// }) => {
//   return (
//     <div className="mb-6 space-y-4">
//       <div className="flex flex-col md:flex-row gap-4">
//         <input
//           type="text"
//           placeholder="Search stores, cities, or states..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//         />
//         <select
//           value={selectedCity}
//           onChange={(e) => setSelectedCity(e.target.value)}
//           className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
//         >
//           {cities.map((city) => (
//             <option key={city} value={city}>
//               {city}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// };

// // Starting Point Display Component
// const StartingPointDisplay = ({ startStore }) => {
//   if (!startStore) return null;

//   return (
//     <div className="mb-6">
//       <div className="p-4 bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-300 rounded-lg">
//         <div className="flex items-center gap-3">
//           <div className="bg-red-600 p-3 rounded-full text-2xl">📍</div>
//           <div>
//             <p className="text-sm font-semibold text-red-800">Starting Point</p>
//             <p className="font-bold text-gray-800 text-lg">{startStore.name}</p>
//             <p className="text-sm text-gray-600">
//               {startStore.city}, {startStore.state}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Main Component
// export default function StoreRouteCalculatorModal({
//   distanceModal,
//   setDistanceModal,
//   locations,
// }) {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isCalculating, setIsCalculating] = useState(false);
//   const [stores, setStores] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedCity, setSelectedCity] = useState("All");
//   const [startStore, setStartStore] = useState(null);
//   const [sequentialRoute, setSequentialRoute] = useState([]);

//   // Fetch coordinates for locations
//   useEffect(() => {
//     if (locations?.length > 0) {
//       const fetchCoordinates = async () => {
//         setIsLoading(true);

//         const results = await Promise.all(
//           locations.map(async (loc, index) => {
//             const { address, city, state, zipCode, storeName } = loc;
//             const coords = await getAddressLatLong(
//               address,
//               city,
//               state,
//               zipCode
//             );

//             return {
//               id: index + 1,
//               name: storeName,
//               city,
//               state,
//               lat: coords?.lat ?? null,
//               lng: coords?.lng ?? null,
//             };
//           })
//         );

//         setStores(results.filter((store) => store.lat && store.lng));
//         setIsLoading(false);
//       };

//       fetchCoordinates();
//     }
//   }, [locations]);

//   const cities = ["All", ...new Set(stores.map((store) => store.city))];

//   const filteredStores = stores.filter((store) => {
//     const matchesSearch =
//       store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       store.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       store.state.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesCity = selectedCity === "All" || store.city === selectedCity;
//     return matchesSearch && matchesCity;
//   });

//   const calculateDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371;
//     const dLat = ((lat2 - lat1) * Math.PI) / 180;
//     const dLon = ((lon2 - lon1) * Math.PI) / 180;
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos((lat1 * Math.PI) / 180) *
//         Math.cos((lat2 * Math.PI) / 180) *
//         Math.sin(dLon / 2) *
//         Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     return R * c;
//   };

//   const formatTime = (seconds) => {
//     const hours = Math.floor(seconds / 3600);
//     const minutes = Math.floor((seconds % 3600) / 60);
//     if (hours > 0) return `${hours}h ${minutes}m`;
//     return `${minutes}m`;
//   };

//   const calculateRoutes = async (selectedStore) => {
//     const allRoutes = stores
//       .filter((store) => store.id !== selectedStore.id)
//       .map((store) => {
//         const distance = calculateDistance(
//           selectedStore.lat,
//           selectedStore.lng,
//           store.lat,
//           store.lng
//         );
//         return {
//           id: store.id,
//           name: store.name,
//           city: store.city,
//           state: store.state,
//           lat: store.lat,
//           lng: store.lng,
//           distanceValue: distance,
//         };
//       })
//       .sort((a, b) => a.distanceValue - b.distanceValue);

//     await calculateSequentialRoute(selectedStore, allRoutes);
//   };

//   const calculateSequentialRoute = async (start, sortedRoutes) => {
//     setIsCalculating(true);
//     const sequence = [];
//     let cumulativeDistanceKm = 0;
//     let cumulativeTimeSeconds = 0;

//     if (window.google && window.google.maps) {
//       const distanceMatrixService =
//         new window.google.maps.DistanceMatrixService();

//       for (let i = 0; i < sortedRoutes.length; i++) {
//         const prevStore = i === 0 ? start : sortedRoutes[i - 1];
//         const currentStore = sortedRoutes[i];

//         try {
//           const result = await new Promise((resolve, reject) => {
//             distanceMatrixService.getDistanceMatrix(
//               {
//                 origins: [{ lat: prevStore.lat, lng: prevStore.lng }],
//                 destinations: [
//                   { lat: currentStore.lat, lng: currentStore.lng },
//                 ],
//                 travelMode: window.google.maps.TravelMode.DRIVING,
//               },
//               (response, status) => {
//                 if (status === "OK") {
//                   resolve(response);
//                 } else {
//                   reject(status);
//                 }
//               }
//             );
//           });

//           const element = result.rows[0].elements[0];

//           if (element.status === "OK") {
//             const segmentDistanceKm = element.distance.value / 1000;
//             const segmentTimeSeconds = element.duration.value;

//             cumulativeDistanceKm += segmentDistanceKm;
//             cumulativeTimeSeconds += segmentTimeSeconds;

//             sequence.push({
//               from: prevStore.name,
//               to: currentStore.name,
//               fromCity: prevStore.city,
//               toCity: currentStore.city,
//               distance: segmentDistanceKm.toFixed(2) + " km",
//               time: formatTime(segmentTimeSeconds),
//               distanceText: element.distance.text,
//               timeText: element.duration.text,
//               cumulativeDistance: cumulativeDistanceKm.toFixed(2) + " km",
//               cumulativeTime: formatTime(cumulativeTimeSeconds),
//               lat: currentStore.lat,
//               lng: currentStore.lng,
//               fromLat: prevStore.lat,
//               fromLng: prevStore.lng,
//             });
//           } else {
//             // Fallback to Haversine
//             const distance = calculateDistance(
//               prevStore.lat,
//               prevStore.lng,
//               currentStore.lat,
//               currentStore.lng
//             );
//             cumulativeDistanceKm += distance;

//             sequence.push({
//               from: prevStore.name,
//               to: currentStore.name,
//               fromCity: prevStore.city,
//               toCity: currentStore.city,
//               distance: distance.toFixed(2) + " km",
//               time: formatTime((distance / 40) * 3600),
//               cumulativeDistance: cumulativeDistanceKm.toFixed(2) + " km",
//               cumulativeTime: formatTime((cumulativeDistanceKm / 40) * 3600),
//               lat: currentStore.lat,
//               lng: currentStore.lng,
//               fromLat: prevStore.lat,
//               fromLng: prevStore.lng,
//             });
//           }
//         } catch (error) {
//           console.error("Distance Matrix API error:", error);
//         }
//       }
//     }

//     setSequentialRoute(sequence);
//     setIsCalculating(false);
//   };

//   const handleStoreClick = (store) => {
//     if (!store.lat || !store.lng) return;
//     setStartStore(store);
//     calculateRoutes(store);
//   };

//   if (!distanceModal) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-[95vw] max-h-[95vh] overflow-hidden flex flex-col w-full">
//         {/* Dialog Header */}
//         <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-6 text-white flex justify-between items-center">
//           <div>
//             <h1 className="text-3xl text-white font-bold">
//               🗺️ Store Route Calculator
//             </h1>
//             <p className="text-indigo-100 mt-1">
//               Calculate optimal routes with real-time Google Maps data
//             </p>
//           </div>
//           <button
//             onClick={() => setDistanceModal(false)}
//             className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
//           >
//             <svg
//               className="w-8 h-8"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Dialog Content */}
//         <div className="p-6 overflow-y-auto flex-1">
//           {isLoading ? (
//             <div className="flex items-center justify-center h-96">
//               <div className="text-center">
//                 <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
//                 <p className="text-gray-600 font-semibold">
//                   Loading store locations...
//                 </p>
//               </div>
//             </div>
//           ) : (
//             <>
//               <SearchFilter
//                 searchTerm={searchTerm}
//                 setSearchTerm={setSearchTerm}
//                 selectedCity={selectedCity}
//                 setSelectedCity={setSelectedCity}
//                 cities={cities}
//               />

//               <div className="mb-6">
//                 <h3 className="text-lg font-semibold text-gray-800 mb-3">
//                   🗺️ Google Maps Route Visualization
//                 </h3>
//                 <GoogleMapComponent
//                   startStore={startStore}
//                   sequentialRoute={sequentialRoute}
//                   stores={stores}
//                   apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
//                 />
//               </div>

//               <StartingPointDisplay startStore={startStore} />

//               <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//                 <div className="lg:col-span-1">
//                   <StoreList
//                     stores={filteredStores}
//                     startStore={startStore}
//                     onStoreClick={handleStoreClick}
//                   />
//                 </div>

//                 <div className="lg:col-span-2">
//                   <SequentialRouteDisplay
//                     sequentialRoute={sequentialRoute}
//                     isCalculating={isCalculating}
//                   />
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
